import { render, staticRenderFns } from "./ZyroStatus.vue?vue&type=template&id=b2f64d5c&scoped=true&"
import script from "./ZyroStatus.vue?vue&type=script&lang=js&"
export * from "./ZyroStatus.vue?vue&type=script&lang=js&"
import style0 from "./ZyroStatus.vue?vue&type=style&index=0&id=b2f64d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f64d5c",
  null
  
)

export default component.exports